<div class="input-autocomplete-container">
  <div class="input-autocomplete__trigger">
    <qr-input
      [config]="config"
      (valueChange)="inputChange($event)"
      [(value)]="selectedOption"
      (click)="showOptions()"
      [isDisabled]="isDisabled"
      [hasError]="hasError"
      (blurChange)="blurChange.emit(true)"
    ></qr-input>
  </div>
  <div
    class="options"
    [class.show]="isOptionsVisible"
    [class.options--multiline]="multilineAddressOptions"
  >
    <span
      class="option subheading-01-semi-bold"
      *ngFor="let option of this.filteredOptions"
      [class.option--multiline]="multilineAddressOptions"
      matRipple
      (click)="select(option)"
      [title]="option"
    >
      {{ option }}
    </span>
  </div>
</div>
